<div class="card bg-white">
  <div class="card-content text-center" *ngIf="!hasPaymentFailure">
    <span class="text-xl font-bold text-primary" i18n>Račun je zaklenjen.</span>
    <p class="mb-2 mt-5">
      <span i18n>Vaš račun za uporabo platforme AutoBrief je trenutno ZAKLENJEN zaradi neuporabe platforme ali neplačila zapadlih obveznosti.</span>
    </p>
    <p class="my-2" *ngIf="accountConfig.activeAccountProductPackage?.paymentUrl">
      <span i18n>Za nadaljnjo uporabo platforme vas prosimo, da račun čim prej poravnate. Do njega lahko dostopate </span><a
            href="{{accountConfig.activeAccountProductPackage.paymentUrl}}" i18n>TUKAJ</a>
    </p>
    <p class="my-2">
      <span i18n>Če ste obveznosti že poravnali ali želite ponovno pridobiti dostop do vašega računa, nas prosimo kontaktirajte na:</span>
    </p>
    <p>
        <span><i class="fa fa-envelope text-gray mr-2"></i><a
                href="mailto:info&#64;briefd.io">info&#64;briefd.io</a></span>
    </p>
    <p>
      <span><i class="fa fa-phone text-gray mr-2"></i><a href="tel:386018280181">+386 (0)1 828 0181</a></span>
    </p>
  </div>

  <div class="card-content text-center" *ngIf="hasPaymentFailure && !showCardForm">
    <span class="text-xl font-bold text-primary" i18n>Plačilo ni uspelo.</span>

    <p class="mb-2 mt-5" *ngIf="failureCategory === 'issuer_decline'">
      <span i18n>Plačilo z vašo kartico je banka zavrnila. Prosimo, preverite stanje z banko (npr. dnevna omejitev, varnostna omejitev) in nato poskusite znova.</span>
    </p>
    <p class="mb-2 mt-5" *ngIf="failureCategory === 'recoverable'">
      <span i18n>Plačilo z vašo kartico ni bilo mogoče izvesti (kartica je morda potekla ali so podatki napačni). Posodobite kartico in poskusite znova.</span>
    </p>
    <p class="mb-2 mt-5" *ngIf="failureCategory !== 'issuer_decline' && failureCategory !== 'recoverable'">
      <span i18n>Plačila ni bilo mogoče izvesti. Prosimo, poskusite znova ali nas kontaktirajte.</span>
    </p>

    <p class="my-2 text-sm text-gray" *ngIf="paymentFailure?.code">
      <span i18n>Koda napake:</span> <span class="font-mono">{{paymentFailure.code}}</span>
    </p>

    <p class="my-2 text-sm text-red" *ngIf="retryError">
      {{retryError}}
    </p>

    <div class="flex flex-col items-center gap-2 mt-4">
      <button type="button" class="btn btn-primary" (click)="retryPayment()" [disabled]="isRetrying || isPreparingCardForm">
        <i class="fa fa-spinner fa-spin mr-2" *ngIf="isRetrying"></i>
        <span i18n>Poskusi znova</span>
      </button>
      <button type="button" class="btn btn-outline" (click)="startUpdateCard()" [disabled]="isRetrying || isPreparingCardForm || !stripePublishableKey">
        <i class="fa fa-spinner fa-spin mr-2" *ngIf="isPreparingCardForm"></i>
        <span i18n>Posodobi plačilno kartico</span>
      </button>
    </div>

    <p class="my-4 text-sm">
      <span i18n>Če težave ne morete rešiti, nas kontaktirajte:</span>
    </p>
    <p>
      <span><i class="fa fa-envelope text-gray mr-2"></i><a href="mailto:info&#64;briefd.io">info&#64;briefd.io</a></span>
    </p>
  </div>

  <div class="card-content" *ngIf="showCardForm && stripeClientSecret && stripePublishableKey">
    <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
      <button type="button"
              class="text-sm text-gray-500 hover:text-primary flex items-center gap-1"
              (click)="onCardFormCancelled()">
        <i class="fa fa-arrow-left"></i>
        <span i18n>Nazaj</span>
      </button>
      <h3 class="text-lg font-semibold text-primary" i18n>Posodobi plačilno kartico</h3>
      <span class="w-12"></span>
    </div>

    <p class="text-sm text-gray-600 mb-4 text-center" i18n>
      Vnesite podatke nove kartice. Po potrditvi bomo poskusili znova izvesti plačilo.
    </p>

    <app-payment-authorization-modal
      [stripeClientSecret]="stripeClientSecret"
      [stripePublishableKey]="stripePublishableKey"
      [skipPolling]="true"
      [embedded]="true"
      (paymentComplete)="onCardAuthorized($event)"
      (paymentCancelled)="onCardFormCancelled()"
      (paymentFailed)="onCardFormFailed($event)"
      (cardSetupError)="onCardSetupError($event)">
    </app-payment-authorization-modal>

    <div *ngIf="isRetrying" class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded flex items-center justify-center gap-2 text-sm text-blue-900">
      <i class="fa fa-spinner fa-spin"></i>
      <span i18n>Obdelujem plačilo...</span>
    </div>
  </div>
</div>
